import { css } from '@emotion/react';
import { useRef, useEffect } from 'react';
import { typography } from '../foundations';

interface CheckboxProps {
  id: string;
  name: string;
  value: string;
  label?: string;
  color: InputTextColors;
  accentColor?: string;
  disabled?: boolean;
  testId?: string;
  checked?: boolean;
  indeterminate?: boolean;
  className?: string;
}

export enum InputTextColors {
  Light = '#5E6C84',
  Dark = '#172B4D'
}

export const textStyle = (color: InputTextColors) => css`
  color: ${color};
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 400;
  margin-left: 8px;
`;

export const containerStyle = css`
  position: relative;
  display: flex;
  align-items: flex-start;
  padding: 2px 0;
  line-height: 1.5;
`;

const checkboxStyle = (accentColor = 'blue') => css`
  accent-color: ${accentColor};
  vertical-align: middle;
  width: 16px;
  height: 16px;
  margin: 4px 0 0;
  &:hover,
  &:focus {
    cursor: pointer;
    background-color: #dfe1e6;
  }
`;

export const Checkbox = (props: CheckboxProps) => {
  const {
    id,
    name,
    value,
    label,
    color,
    accentColor,
    disabled,
    testId,
    checked,
    indeterminate,
    className
  } = props;
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current) {
      if (indeterminate) {
        ref.current.indeterminate = indeterminate;
      } else {
        ref.current.checked = checked || false;
      }
    }
  }, [props]);

  return (
    <div className={className} css={[containerStyle, typography]}>
      <input
        id={id}
        type="checkbox"
        data-testid={testId ? testId : id}
        css={checkboxStyle(accentColor)}
        ref={ref}
        name={name}
        value={value}
        disabled={disabled || false}
      />
      {label && (
        <label css={textStyle(color)} htmlFor={id}>
          {label}
        </label>
      )}
    </div>
  );
};
